import * as types from './types';

export default {
  [types.GET_USER_INFORMATION]: state => state.userInformation,
  [types.GET_ASSESSMENT]: state => state.assessment,
  [types.GET_DICTIONARY]: state => state.dictionary,
  [types.GET_ANSWERERINFO]: state => state.answererInfo
};



// WEBPACK FOOTER //
// ./src/store/getters.js